// extracted by mini-css-extract-plugin
export default {"icon":"IconLink_icon__x-MWs","link":"IconLink_link__6MGpH"};